import React from "react";

export function LinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="18px"
      width="18px"
      viewBox="0 0 24 24"
      color="neutral5"
      title="Website"
      class="sc-aef7b723-0 bKkusY"
    >
      <path d="M11.877 15.9787C11.8146 16.8242 11.4524 17.6196 10.8555 18.2217L9.94675 19.1305C9.27191 19.7958 8.36141 20.1672 7.41381 20.1638C6.46621 20.1604 5.5584 19.7825 4.88834 19.1124C4.21828 18.4423 3.84034 17.5345 3.83695 16.5868C3.83355 15.6392 4.20497 14.7287 4.87021 14.0538L5.779 13.145C6.38116 12.5483 7.1765 12.186 8.02192 12.1235L9.67229 10.4731C8.76285 10.2319 7.80611 10.2331 6.89728 10.4766C5.98845 10.72 5.15923 11.1973 4.49215 11.8608L3.58335 12.7697C2.56946 13.7837 1.99991 15.159 2 16.5929C2.00009 18.0269 2.5698 19.4021 3.5838 20.416C4.59781 21.43 5.97305 21.9995 7.40698 21.9994C8.84092 21.9994 10.2161 21.4296 11.23 20.4156L12.1388 19.5068C12.802 18.8395 13.279 18.0102 13.5225 17.1014C13.7659 16.1926 13.7673 15.236 13.5265 14.3265L11.877 15.9787Z"></path>
      <path d="M15.9793 11.8768C16.8248 11.8144 17.6202 11.4522 18.2222 10.8553L19.131 9.9465C19.7963 9.27163 20.1677 8.3611 20.1643 7.41348C20.1609 6.46585 19.783 5.55801 19.1129 4.88793C18.4429 4.21786 17.535 3.83991 16.5874 3.83651C15.6398 3.83312 14.7293 4.20455 14.0545 4.8698L13.1457 5.77863C12.549 6.3808 12.1868 7.17616 12.1242 8.02161L10.4738 9.67203C10.2327 8.76256 10.2339 7.80579 10.4773 6.89693C10.7208 5.98807 11.198 5.15883 11.8616 4.49173L12.7704 3.58291C13.7844 2.56899 15.1596 1.99943 16.5935 1.99951C18.0275 1.9996 19.4027 2.56932 20.4165 3.58336C21.4304 4.5974 22 5.97267 21.9999 7.40665C21.9998 8.84063 21.4301 10.2158 20.4161 11.2298L19.5073 12.1386C18.84 12.8018 18.0108 13.2789 17.102 13.5223C16.1932 13.7658 15.2366 13.7672 14.3271 13.5264L15.9793 11.8768Z"></path>
      <path d="M8.36434 16.5441C8.18462 16.5441 8.00895 16.4907 7.85954 16.3909C7.71012 16.291 7.59367 16.1491 7.5249 15.983C7.45613 15.817 7.43814 15.6343 7.47319 15.458C7.50824 15.2817 7.59476 15.1198 7.72182 14.9927L14.9922 7.72213C15.1636 7.55658 15.3932 7.46498 15.6315 7.46705C15.8697 7.46912 16.0977 7.5647 16.2662 7.7332C16.4347 7.9017 16.5302 8.12965 16.5323 8.36794C16.5344 8.60623 16.4428 8.8358 16.2772 9.00721L9.00686 16.2778C8.83646 16.4483 8.60535 16.544 8.36434 16.5441Z"></path>
    </svg>
  );
}

export function FeeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="18px"
      width="18px"
      viewBox="0 0 24 24"
      color="neutral5"
      title="Fees"
      class="sc-aef7b723-0 bKkusY"
    >
      <path d="M20.25 19.4349H19.5V13.1738H18V19.4349H15V13.1738H13.5V19.4349H10.5V13.1738H9V19.4349H6V13.1738H4.5V19.4349H3.75C3.336 19.4349 3 19.7847 3 20.2175C3 20.6503 3.336 21.0001 3.75 21.0001H20.25C20.664 21.0001 21 20.6503 21 20.2175C21 19.7847 20.664 19.4349 20.25 19.4349Z"></path>
      <path d="M20.6092 7.79137L12.3593 3.09558C12.135 2.96879 11.865 2.96879 11.6407 3.09558L3.39075 7.79137C3.15 7.92833 3 8.19207 3 8.47852V10.8264C3 11.2592 3.336 11.609 3.75 11.609H20.25C20.664 11.609 21 11.2592 21 10.8264V8.47852C21 8.19207 20.85 7.92833 20.6092 7.79137ZM12 9.26115C11.1713 9.26115 10.5 8.56069 10.5 7.69588C10.5 6.83108 11.1713 6.13062 12 6.13062C12.8287 6.13062 13.5 6.83108 13.5 7.69588C13.5 8.56069 12.8287 9.26115 12 9.26115Z"></path>
    </svg>
  );
}

export function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="18px"
      width="18px"
      viewBox="0 0 24 24"
      color="neutral5"
      title="Twitter"
      class="sc-aef7b723-0 bKkusY"
    >
      <path
        d="M22 5.89691C21.25 6.2268 20.5 6.47423 19.6667 6.5567C20.5 6.06186 21.1667 5.23711 21.5 4.3299C20.6667 4.82474 19.8333 5.15464 18.9167 5.31959C18.1667 4.49485 17.0833 4 15.9167 4C13.6667 4 11.8333 5.81443 11.8333 8.04124C11.8333 8.37113 11.8333 8.70103 11.9167 8.94845C8.41667 8.7835 5.41667 7.13402 3.41667 4.65979C3 5.31959 2.83333 5.97938 2.83333 6.72165C2.83333 8.12371 3.58333 9.36082 4.66667 10.1031C4 10.1031 3.33333 9.93814 2.83333 9.60825C2.83333 9.60825 2.83333 9.60825 2.83333 9.69072C2.83333 11.6701 4.25 13.3196 6.08333 13.6495C5.75 13.732 5.41667 13.8144 5 13.8144C4.75 13.8144 4.5 13.8144 4.25 13.732C4.75 15.3814 6.25 16.5361 8.08333 16.5361C6.66667 17.6082 4.91667 18.268 3 18.268C2.66667 18.268 2.33333 18.268 2 18.1856C3.83333 19.3402 6 20 8.25 20C15.8333 20 19.9167 13.8144 19.9167 8.45361C19.9167 8.28866 19.9167 8.12371 19.9167 7.95876C20.75 7.38144 21.4167 6.63917 22 5.89691Z"
        fill="currenColor"
      ></path>
    </svg>
  );
}
